import type { SimulationRun } from '@library/types/simulations';
import { useGetSimulationQuery } from '@bo-services/simulationsApi';

export function useSimulation({
  gameId,
  leagueId,
  simulationId
}: {
  gameId?: string;
  gameStartTime?: string;
  leagueId?: string;
  simulationId?: string;
}): {
  simulation?: SimulationRun;
  isSimulationError: boolean;
  isSimulationLoading: boolean;
} {
  const {
    data: simulation,
    isError: isSimulationError,
    isFetching,
    isLoading
  } = useGetSimulationQuery(
    {
      gameId: gameId ?? '',
      leagueId: leagueId ?? '',
      simulationId: simulationId ?? ''
    },
    {
      skip:
        !leagueId ||
        !gameId ||
        !simulationId ||
        simulationId === 'NEW' ||
        simulationId === '1'
    }
  );

  const isSimulationLoading = isLoading || isFetching;

  return {
    // TODO: incorporate types
    simulation,
    isSimulationError,
    isSimulationLoading
  };
}
